import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-075fffb7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "loader-spinner"
}
const _hoisted_3 = { key: 1 }


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingWrapper',
  props: {
  loading: {
    type: Boolean,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (__props.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "default")
            ]))
      ]),
      _: 3 /* FORWARDED */
    })
  ]))
}
}

})